/* eslint-disable */
export default {
  _level_background: 'level_background',
  _title: 'title',
  _variants_Popup: 'variants/Popup',
  _word_bank_party_ride: 'word_bank_party_ride',
  _word_bank_lake_friends: 'word_bank_lake_friends',
  _word_bank_birthday_bash: 'word_bank_birthday_bash',
  _awesome: 'awesome',
  _InstructionsPopup: 'InstructionsPopup',
  _HomeBtnPopup: 'HomeBtnPopup',
  _great_job: 'great_job',
  _yay: 'yay',
  _TITLE_stages: 'TITLE_stages',
  _robot_arm: 'robot_arm',
  _BTN_birthday_bash: 'BTN_birthday_bash',
  _BTN_breakfast: 'BTN_breakfast',
  _BTN_buggy_cuppy: 'BTN_buggy_cuppy',
  _BTN_check_up: 'BTN_check_up',
  _BTN_cow_tour: 'BTN_cow_tour',
  _BTN_lake_friends: 'BTN_lake_friends',
  _BTN_lost_lunch: 'BTN_lost_lunch',
  _BTN_night_attic: 'BTN_night_attic',
  _BTN_party_ride: 'BTN_party_ride',
  _BTN_queenly_home: 'BTN_queenly_home',
  _selected_BTN: 'selected_BTN',
  _BTN_play: 'BTN_play',
  _OkBtn: 'OkBtn',
  _variants_Btn_PlayAgain: 'variants/Btn_PlayAgain',
  _NoBtn: 'NoBtn',
  _YesBtn: 'YesBtn',
  _BTN_home: 'BTN_home',
  _speaker_off_button: 'speaker_off_button',
  _speaker_on_button: 'speaker_on_button',
  _star: 'star',
  _close_button: 'close_button',
  _background: 'background',
  _word_bank_buggy_cuppy: 'word_bank_buggy_cuppy',
  _word_bank_breakfast: 'word_bank_breakfast',
  _word_bank_night_attic: 'word_bank_night_attic',
  _word_bank_lost_lunch: 'word_bank_lost_lunch',
  _birthday_bash: 'birthday_bash',
  _home_button_menu: 'home_button_menu',
  _word_bank_queenly_home: 'word_bank_queenly_home',
  _word_bank_check_up: 'word_bank_check_up',
  _word_bank_cow_tour: 'word_bank_cow_tour',
  _buggy_cuppy: 'buggy_cuppy',
  _cow_tour: 'cow_tour',
  _lake_friends: 'lake_friends',
  _night_attic: 'night_attic',
  _party_ride: 'party_ride',
  _queenly_home: 'queenly_home',
  _breakfast: 'breakfast',
  _lost_lunch: 'lost_lunch',
}